// extracted by mini-css-extract-plugin
export default {"pledge":"pledge--mp-hPqkz"};